import React from "react";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { useNavigate } from "react-router-dom";
import { dataTrigger } from "@/analytics";
import cls from "./styles.module.scss";

export const ConditionsBlock = () => {
  const navigate = useNavigate();

  const openModal = () => {
    navigate("/conditions");
  };

  return (
    <FlexRow
      gap={4}
      justifyContent="space-between"
      className={cls.conditions}
      onClick={openModal}
      role="button"
      {...dataTrigger("ref.main.conditions")}
    >
      <FlexColumn gap={2}>
        <Typography className={cls.title}>Условия программы</Typography>
        <Typography className={cls.desc}>
          Акции по регионам и категориям
        </Typography>
      </FlexColumn>

      <div className={cls.arrowBtn}>→</div>
    </FlexRow>
  );
};
